module.exports = __webpack_public_path__ + "static/media/woman.359a04b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/woman.svg
// module id = 147
// module chunks = 0